import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'bypassSanitizeHtml' })
export class BypassSanitizeHtml implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) { }
  transform(v: string): SafeHtml { return this._sanitizer.bypassSecurityTrustHtml(v || ''); }
}

@Pipe({ name: 'bypassSanitizeStyle' })
export class BypassSanitizeStyle implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) { }
  transform(v: string): SafeStyle { return this._sanitizer.bypassSecurityTrustStyle(v || ''); }
}

@Pipe({ name: 'bypassSanitizeUrl' })
export class BypassSanitizeUrl implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) { }
  transform(v: string): SafeResourceUrl { return this._sanitizer.bypassSecurityTrustResourceUrl(v || ''); }
}

